<template>
	<SOSlotModal
		:modal-title="pageSetting.modal.title"
		:modal-id="pageSetting.modal.id"
		:no-padding="true"
		@close="close"
	>
		<template v-slot:modal-body>
			<div style="max-height: 300px; overflow: scroll">
				<div class="p-x-20 p-y-20" @click="pilihPerangkat({iddevice: '', nama: '', number: ''})">
					<div class="d-flex-between-center">
						<div>
							<div class="f-semi f-16 f-c-black">WA Smartlink</div>
							<div class="f-regular f-14 f-c-midgrey">Nomor bawaan dari Smartlink</div>
						</div>
						<div>
							<IconBased width="16" height="16" v-if="selectedWaDevice === ''">
								<template v-slot:icons>
									<RadioCheckedBlue/>
								</template>
							</IconBased>
							<IconBased width="16" height="16" v-else>
								<template v-slot:icons>
									<RadioUnChecked/>
								</template>
							</IconBased>
						</div>
					</div>
				</div>
				<div class="separator"></div>
				<div class="p-x-20 p-y-20" v-for="device in waDevice" @click="pilihPerangkat(device)" :key="device.iddevice">
					<div class="d-flex-between-center">
						<div>
							<div class="f-semi f-16 f-c-black nomore" style="width: 250px">{{ device.nama }}</div>
							<div class="f-regular f-14 f-c-midgrey">
								{{ device.country_code + device.number }}
								<span :class="{'f-c-red': device.status !== 1, 'f-c-green': device.status === 1}">
									{{ device.status !== 1 ? "(Masa aktif kedaluwarsa)" : "(Terhubung)" }}
								</span>
							</div>
						</div>
						<div>
							<IconBased width="16" height="16" v-if="selectedWaDevice === device.iddevice">
								<template v-slot:icons>
									<RadioCheckedBlue/>
								</template>
							</IconBased>
							<IconBased width="16" height="16" v-else>
								<template v-slot:icons>
									<RadioUnChecked/>
								</template>
							</IconBased>
						</div>
					</div>
				</div>
				<div class="bg-grey p-x-20 p-d-12" v-if="waDevice.length === 0">
					<div class="f-regular f-14 f-c-midgrey">
						Silakan berlangganan Whatsapp Premium untuk menggunakan perangkat sendiri.
					</div>
				</div>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {moduleName} from "@/modules/wa-blast/store/state"
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import IconBased from "@/modules/wa-autosender/components/iconPack/IconBased";
import RadioCheckedBlue from "@/modules/wa-autosender/components/iconPack/RadioCheckedBlue1616";
import RadioUnChecked from "@/modules/wa-autosender/components/iconPack/RadioUnChecked1616";

export default {
	name: "PilihPerangkatModal",
	components: {
		SOSlotModal,
		IconBased,
		RadioCheckedBlue,
		RadioUnChecked,
	},
	props: {
		reminderType: {
			type: String,
			default: "",
		},
		selectedWaDevice: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			customerTemp: {},
			pageSetting: {
				modal: {
					title: "Pilih Perangkat",
					id: "modal-pilih-perangkat-wa"
				},
				btn: {
					save: {
						disabled: false,
						loading: false,
					}
				}
			},
		}
	},
	mounted() {
		$("#" + this.pageSetting.modal.id).modal("show");
	},
	computed: {
		...mapGetters(moduleName, {
			waDevice: "waDevice",
		}),
	},
	methods: {
		...mapActions("pengaturanUmumModule", {
			getInfo: "getReminderInfo",
		}),

		async pilihPerangkat(device) {
			const form = {
				type: this.reminderType,
				iddevice: device.iddevice
			}
			const res = await this.$store.dispatch("pengaturanUmumModule/perangkatReminder", form)
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.getInfo()
			this.$toast.success(res.msg)
			this.close()

			// delay 1 detik untuk refresh data (tidak bisa realtime tidak tau kenapa di be)
			if (this.reminderType == "poin") {
				await new Promise(resolve => setTimeout(resolve, 1000));
				this.getInfo()
			}
		},
		close() {
			$("#" + this.pageSetting.modal.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		}
	}
}
</script>